import React, { Component, Fragment } from 'react';

import Logo_Leroy from 'assets/images/logo_leroy.png';
import './styles.scss';

export default Page =>
  class extends Component {
    render() {
      return (
        <Fragment>
          <div className="account-pages">
            <div className="clearfix" />
            <div className="header">
              <div className="main--container">
                <div className="row">
                  <div className="col-xs-12">
                    <a href="index.html" className="header-logo" title="Leroy Merlin com Você">
                      <img className="image" src={Logo_Leroy} alt="Leroy Merlin com Você" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="wrapper">
              <Page {...this.props} />
            </div>
          </div>
        </Fragment>
      );
    }
  };
